import { motion } from "motion/react";

import { BankIDLogin } from "./BankIDLogin";
import { useLoginStore } from "./loginStore";
import { PasswordLoginForm } from "./PasswordLoginForm";

const Login = () => {
  const [loginMethod, setLoginMethod] = useLoginStore((state) => [
    state.loginMethod,
    state.setLoginMethod,
  ]);

  return (
    <div className="flex h-screen flex-col bg-white">
      <div className="flex flex-1 items-center justify-center px-4 py-12">
        <motion.div
          key={loginMethod}
          initial="initial"
          animate="animate"
          exit="exit"
          variants={{
            initial: {
              opacity: 0,
              scale: 0,
            },
            animate: {
              opacity: 1,
              scale: 1,
            },
            exit: {
              opacity: 0,
              scale: 0,
              transition: {
                duration: 0.2,
              },
            },
          }}
          transition={{
            type: "tween",
            duration: 0.3,
            ease: "easeOut",
          }}
          className="w-full"
        >
          {loginMethod === "bankid" ? (
            <BankIDLogin
              onSwitchToPassword={() => setLoginMethod("password")}
            />
          ) : (
            <PasswordLoginForm
              onSwitchToBankID={() => setLoginMethod("bankid")}
            />
          )}
        </motion.div>
      </div>
    </div>
  );
};

export { Login };
